import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "./styles/layout/layout.scss";
import "./styles/theme-overrides.css";

import "primereact/resources/themes/lara-light-green/theme.css";

import { Auth0Provider } from "@auth0/auth0-react";
import { LayoutProvider } from "./layout/context/layoutcontext";

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN!}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID!}
      authorizationParams={{
        redirect_uri: window.location.origin,
      }}
      cacheLocation="localstorage" // Persist Auth0 session across reloads
    >
      <LayoutProvider>
        <App />
      </LayoutProvider>
    </Auth0Provider>
  </React.StrictMode>
);
